import React from 'react'

import SvgIcon from './SvgIcon'
import { trackedClick } from '../utils'
import Loader from './Loader'

const NewsItem = ({ pubDate, title, link, content }) => {
    const date = new Date(pubDate.replace(/ /g, 'T')) // works both in Safari and Chrome, and in FF
    const day = date.getDate()
    const monthIndex = 1 + date.getMonth()
    const month = monthIndex < 10 ? `0${monthIndex}` : monthIndex
    const div = document.createElement('div')
    div.innerHTML = content
    const preview = div.innerText.trim()
    return (
        <div className="news-previews__item">
            <div className="news-preview">
                <time className="news-preview__date" title={date}>
                    {day}.{month}
                </time>
                <h5 className="news-preview__title" title={title}>
                    {title}
                </h5>
                <div
                    className="news-preview__more"
                    title={`${preview.slice(0, 200)}...`}
                >
                    <a
                        href={link}
                        target="_blank"
                        rel="noopener noreferrer"
                        title="Show more"
                        onClick={trackedClick('News link clicked', {
                            source: 'MT intent page',
                            title,
                        })}
                    >
                        Show more
                    </a>
                </div>
            </div>
        </div>
    )
}

class NewsPreview extends React.Component {
    state = {
        hideNews: false,
    }

    render() {
        const { news = [], loading } = this.props
        if (this.state.hideNews) {
            return false
        }
        if (loading) {
            return (
                <section className="news-previews">
                    <div className="news-previews__container container">
                        <Loader style={{ margin: 'auto' }} />
                    </div>
                </section>
            )
        }
        return (
            <section className="news-previews">
                <div className="news-previews__container container">
                    <div className="news-previews__inner">
                        <div
                            className="news-previews__close"
                            role="button"
                            tabIndex="0"
                            onClick={this.handleClick}
                            onKeyPress={this.handleClick}
                        >
                            <SvgIcon slug="circle-cross" />
                        </div>
                        <h2 className="news-previews__title">News</h2>
                        <div className="news-previews__list">
                            {news.slice(0, 3).map(item => (
                                <NewsItem key={item.link} {...item} />
                            ))}
                        </div>
                    </div>
                </div>
            </section>
        )
    }

    handleClick = () => {
        this.setState({
            hideNews: true,
        })
    }
}

export default NewsPreview



// WEBPACK FOOTER //
// /usr/src/app/frontend/src/components/NewsPreview.jsx